var _defs, _tspan;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHomeMain(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 469,
    height: 469,
    id: "svg5901",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs5905"
  })), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    style: {
      fontSize: 40,
      lineHeight: 1.25,
      fontFamily: "Gotham"
    },
    x: 51.358604,
    y: 303.0722,
    id: "text20183"
  }, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan20181",
    x: 51.358604,
    y: 303.0722
  }))), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: 900,
      fontStretch: "normal",
      fontSize: "53.8628px",
      lineHeight: 1.25,
      fontFamily: "Arial",
      fill: "#ffffff",
      strokeWidth: 1.34658
    },
    x: 21.797689,
    y: 273.16562,
    id: "text6366",
    transform: "scale(1.0170211,0.98326378)"
  }, /*#__PURE__*/React.createElement("tspan", {
    id: "tspan6364",
    x: 21.797689,
    y: 273.16562,
    style: {
      strokeWidth: 1.34658
    }
  }, "SIMPLE")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: 900,
      fontStretch: "normal",
      fontSize: "54.1663px",
      lineHeight: 1.25,
      fontFamily: "Arial",
      fill: "#00ff8d",
      fillOpacity: 1,
      strokeWidth: 1.35417
    },
    x: 245.71616,
    y: 273.5502,
    id: "text8826",
    transform: "scale(1.0227511,0.97775498)"
  }, /*#__PURE__*/React.createElement("tspan", {
    id: "tspan8824",
    x: 245.71616,
    y: 273.5502,
    style: {
      fill: "#00ff8d",
      fillOpacity: 1,
      strokeWidth: 1.35417
    }
  }, "ADMIN")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: 900,
      fontStretch: "normal",
      fontSize: "15.2744px",
      lineHeight: 1.25,
      fontFamily: "Arial",
      fill: "#ffffff",
      strokeWidth: 1.28551
    },
    x: 58.397259,
    y: 279.95667,
    id: "text20717",
    transform: "scale(0.97090159,1.0299705)"
  }, /*#__PURE__*/React.createElement("tspan", {
    id: "tspan20715",
    x: 58.397259,
    y: 279.95667,
    style: {
      fontSize: "15.2744px",
      strokeWidth: 1.28551
    }
  }, "MODERATION TOOLS FOR YOUR COMMUNITY")));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeMain);
export default __webpack_public_path__ + "static/media/home-main.b05c7f8c9306c67e0bb2fa66340183c9.svg";
export { ForwardRef as ReactComponent };